var _rect, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245,
    height: 246,
    preserveAspectRatio: "xMidYMid meet",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,246) scale(0.10000000149011612,-0.10000000149011612) ",
    fill: "#6d5189",
    stroke: "none",
    id: "svg_1",
    className: "",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1140 2311 c-363 -50 -622 -345 -622 -706 l0 -101 -66 -34 c-255 -132 -404 -417 -371 -708 19 -168 81 -295 203 -418 144 -144 294 -207 496 -207 78 -1 136 5 180 17 78 20 181 67 229 103 27 21 37 24 50 15 59 -42 157 -90 226 -110 102 -31 275 -35 375 -9 406 106 634 532 496 929 -36 103 -82 173 -171 263 -57 58 -101 92 -155 119 l-75 39 -1 106 c-1 127 -19 204 -76 318 -126 257 -435 422 -718 384z m298 -105 c87 -30 128 -54 201 -115 99 -83 172 -200 206 -330 15 -57 24 -216 13 -227 -3 -2 -27 0 -54 6 -27 6 -92 11 -144 11 -146 0 -248 -31 -406 -126 l-30 -18 -69 41 c-135 82 -239 107 -407 99 -62 -3 -123 -8 -135 -12 -23 -7 -23 -6 -23 72 0 244 136 460 359 573 94 47 166 60 301 56 90 -3 131 -10 188 -30z m-514 -741 c73 -15 175 -59 215 -92 l23 -19 -51 -68 c-57 -75 -102 -158 -121 -223 -7 -24 -19 -43 -26 -43 -25 0 -165 103 -214 158 -52 59 -125 193 -136 249 -6 30 -5 32 32 38 22 4 44 8 49 10 27 9 168 3 229 -10z m867 4 l51 -11 -6 -37 c-9 -58 -74 -175 -135 -242 -52 -58 -189 -159 -215 -159 -6 0 -17 19 -24 43 -23 73 -72 163 -124 228 l-51 63 24 19 c37 30 146 78 214 92 75 17 198 18 266 4z m-1236 -100 c52 -163 193 -322 364 -408 l43 -23 -5 -51 c-15 -164 46 -354 160 -494 24 -29 43 -57 43 -62 0 -19 -127 -81 -206 -102 -97 -25 -242 -27 -329 -4 -201 52 -373 210 -442 405 -32 91 -42 246 -23 342 26 133 120 287 224 367 47 36 134 91 146 91 3 0 14 -28 25 -61z m1425 30 c132 -70 248 -213 295 -362 21 -64 27 -104 28 -182 1 -122 -13 -185 -65 -293 -46 -98 -144 -208 -232 -261 -202 -122 -471 -125 -663 -9 -29 18 -53 36 -53 41 0 5 18 30 41 55 103 117 160 273 163 445 l2 108 75 41 c144 79 295 262 331 401 6 26 14 47 16 47 2 0 30 -14 62 -31z m-696 -159 c49 -62 101 -163 112 -216 5 -27 3 -33 -16 -39 -65 -21 -246 -20 -311 0 -27 9 -21 43 26 139 31 65 116 176 134 176 5 0 29 -27 55 -60z m-141 -342 c76 -10 212 -1 260 17 15 6 17 -1 17 -76 0 -154 -54 -301 -147 -408 l-47 -54 -43 48 c-93 106 -142 234 -150 389 -6 104 -5 109 13 102 10 -4 54 -12 97 -18z",
    id: "svg_2",
    fill: "#6d5189",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturationIcon);
export default __webpack_public_path__ + "static/media/saturation-icon.c7cf5598c0b68759c539cab3a6025700.svg";
export { ForwardRef as ReactComponent };